var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5188 3.7572C10.1756 1.41405 6.37666 1.41405 4.03351 3.7572C3.77316 4.01755 3.35105 4.01755 3.0907 3.7572C2.83035 3.49685 2.83035 3.07474 3.0907 2.81439C5.95455 -0.0494576 10.5978 -0.049457 13.4616 2.81439C16.3254 5.67823 16.3254 10.3214 13.4616 13.1853C10.5978 16.0491 5.95455 16.0491 3.0907 13.1853C2.83035 12.9249 2.83035 12.5028 3.0907 12.2425C3.35105 11.9821 3.77316 11.9821 4.03351 12.2425C6.37666 14.5856 10.1756 14.5856 12.5188 12.2425C14.8619 9.89933 14.8619 6.10034 12.5188 3.7572ZM6.89042 5.50173C7.16561 5.25712 7.58699 5.2819 7.83161 5.55709L9.60938 7.55709C9.83391 7.80968 9.83391 8.19032 9.60938 8.44291L7.83161 10.4429C7.58699 10.7181 7.16561 10.7429 6.89042 10.4983C6.61524 10.2537 6.59045 9.83228 6.83506 9.55709L7.62655 8.66667H0.666667C0.298477 8.66667 0 8.36819 0 8C0 7.63181 0.298477 7.33333 0.666667 7.33333H7.62655L6.83506 6.44291C6.59045 6.16772 6.61524 5.74634 6.89042 5.50173Z",
    fill: "#141F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogout);
export default __webpack_public_path__ + "static/media/ProfileLogout.da8c6b8c2606375b63cd9cf159ec5c0e.svg";
export { ForwardRef as ReactComponent };